import { useEffect } from 'react';

const MQ = '(max-width: 1023px)';

export function useMobileAppChrome() {
  useEffect(() => {
    const root = document.documentElement;
    const apply = () => {
      const on = window.matchMedia(MQ).matches;
      if (on) root.setAttribute('data-d88-mobile-app', '1');
      else root.removeAttribute('data-d88-mobile-app');
    };
    apply();
    const mq = window.matchMedia(MQ);
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);
}
